import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function IsForYouSection() {
  return <section className="py-12 md:py-16 px-4 bg-slate-950 border-y border-slate-800/50" data-id="element-185">
      <div className="max-w-4xl mx-auto" data-id="element-186">
        <FadeIn className="text-center mb-8" data-id="element-187">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white tracking-wide" data-id="element-188">
            ¿ESTE SISTEMA ES PARA VOS?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-189">
          {/* Para vos */}
          <FadeIn delay={0.1} data-id="element-190">
            <div className="bg-slate-900 border border-green-500/30 rounded-2xl p-8 h-full" data-id="element-191">
              <div className="flex items-center gap-3 mb-6 pb-6 border-b border-slate-800" data-id="element-192">
                <CheckCircle2 className="w-8 h-8 text-green-500" data-id="element-193" />
                <h3 className="text-xl font-bold text-white" data-id="element-194">
                  Este sistema es para vos si...
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-195">
                {['Sos ciclista amateur y salís los fines de semana con grupo o solo', 'Querés dejar de llegar cortado en las subidas y empezar a llegar con el grupo', 'Entrenás pero no ves transferencia real a tus salidas', 'Querés un sistema claro sin tecnología cara ni teoría abstracta', 'Tenés entre 35 y 60 años y creés que ya no podés mejorar'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-196">
                    <span className="text-green-500 mt-1" data-id="element-197">✓</span>
                    <span className="text-slate-300" data-id="element-198">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* NO para vos */}
          <FadeIn delay={0.2} data-id="element-199">
            <div className="bg-slate-900 border border-red-500/30 rounded-2xl p-8 h-full" data-id="element-200">
              <div className="flex items-center gap-3 mb-6 pb-6 border-b border-slate-800" data-id="element-201">
                <XCircle className="w-8 h-8 text-red-500" data-id="element-202" />
                <h3 className="text-xl font-bold text-white" data-id="element-203">
                  Este sistema NO es para vos si...
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-204">
                {['Buscás un curso teórico sin comprometerte con el proceso', 'No te interesa aplicar un método y preferís seguir improvisando', 'Sos ciclista profesional con entrenador personal y equipo de alto rendimiento'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-205">
                    <span className="text-red-500 mt-1" data-id="element-206">✕</span>
                    <span className="text-slate-300" data-id="element-207">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}